<template>
  <div class="icc__block">
    <div class="icc__block-body">
      <div class="icc__block-container icc__block-overflow pb-4">
        <div class="icc__block-row">
          <div class="icc__block-text">
            <div class="icc__block-title">
              Выберите лабораторные исследования, которые Вам необходимы при
              обследовании данной пациентки?
            </div>
            <div class="d-none d-xl-block">
              <RadioButton
                class="mt-6 mb-2 radiobtn_simple"
                :inputValue="0"
                v-model="radioTabs[0]"
                :label="'Биохимический анализ крови'"
              />
              <RadioButton
                class="mb-2 radiobtn_simple"
                :inputValue="1"
                v-model="radioTabs[0]"
                :label="'Липидный профиль'"
              />
              <RadioButton
                class="mb-2 radiobtn_simple"
                :inputValue="2"
                v-model="radioTabs[0]"
                :label="'Гликированный гемоглобин'"
              />
              <RadioButton
                class="mb-2 radiobtn_simple"
                :inputValue="3"
                v-model="radioTabs[0]"
                :label="'Тропонин'"
              />
              <RadioButton
                class="mb-2 radiobtn_simple"
                :inputValue="4"
                v-model="radioTabs[0]"
                :label="'NT – proBNP'"
              />
              <RadioButton
                class="mb-2 radiobtn_simple"
                :inputValue="5"
                v-model="radioTabs[0]"
                :label="'Суточная альбуминурия'"
              />
              <RadioButton
                class="mb-2 radiobtn_simple"
                :inputValue="6"
                v-model="radioTabs[0]"
                :label="'ТТГ, Т4 свободный'"
              />
              <RadioButton
                class="mb-2 radiobtn_simple"
                :inputValue="7"
                v-model="radioTabs[0]"
                :label="'Кортизол'"
              />
            </div>
            <div class="d-xl-none">
              <Select
                :placeholder="'Выберите результат'"
                :items="list"
                :multiple="false"
                v-model="radioTabs"
                :searchable="false"
              >
                <template #list-header>
                  <div class="select-form__select-header">
                    Выберите результат
                  </div>
                </template>
              </Select>
            </div>
          </div>
          <div
            class="icc__block-white-plate"
            :style="`opacity: ${radioTabs[0] == null ? '0' : '1'}`"
          >
            <div
              class="d-flex direction-column icc__block-white-plate-overflow"
              v-if="radioTabs[0] == 0"
            >
              <div class="title-1 mb-4">Биохимический анализ крови</div>
              <div class="text-2 mb-4">
                <b>Расчётная СКФ по CKD-EPI:</b> 45,33 мл/мин/1,73м&#178;
              </div>
              <div class="full-screen mb-4">
                <div
                  class="full-screen__trigger"
                  :data-coolbox="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step7__table1.jpg
                  `"
                >
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="40" height="40" rx="8" fill="#830051"></rect>
                    <path
                      d="M23 11H29V17"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M17 29H11V23"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M29 11L22 18"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M11 29L18 22"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </div>

                <img
                  :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step7__table1.jpg 3x`"
                />
              </div>
            </div>
            <div
              class="d-flex direction-column icc__block-white-plate-overflow"
              v-if="radioTabs[0] == 1"
            >
              <div class="title-1 mb-4">Липидный профиль</div>
              <div class="full-screen mb-4">
                <div
                  class="full-screen__trigger"
                  :data-coolbox="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step7__table2.jpg
                  `"
                >
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="40" height="40" rx="8" fill="#830051"></rect>
                    <path
                      d="M23 11H29V17"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M17 29H11V23"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M29 11L22 18"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M11 29L18 22"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </div>

                <img
                  :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step7__table2.jpg 3x`"
                />
              </div>
            </div>
            <div
              class="d-flex direction-column icc__block-white-plate-overflow"
              v-if="radioTabs[0] == 2"
            >
              <div class="title-1 mb-4">Гликированный гемоглобин</div>
              <div class="full-screen mb-4">
                <div
                  class="full-screen__trigger"
                  :data-coolbox="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step7__table3.jpg
                  `"
                >
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="40" height="40" rx="8" fill="#830051"></rect>
                    <path
                      d="M23 11H29V17"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M17 29H11V23"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M29 11L22 18"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M11 29L18 22"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </div>

                <img
                  :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/interactive-clinical-case/step7__table3.jpg 3x`"
                />
              </div>
            </div>
            <div
              class="d-flex direction-column icc__block-white-plate-overflow"
              v-if="radioTabs[0] == 3"
            >
              <div class="title-1 mb-4">Тропонин</div>
              <div class="text-2 mb-4">
                14,7 пг/мл (клиническое пороговое значение 100 пг/мл)
              </div>
            </div>
            <div
              class="d-flex direction-column icc__block-white-plate-overflow"
              v-if="radioTabs[0] == 4"
            >
              <div class="title-1 mb-4">NT – proBNP</div>
              <div class="text-2 mb-4">
                740 пг/мл (референсные значения &lt;300 пг/мл)
              </div>
            </div>
            <div
              class="d-flex direction-column icc__block-white-plate-overflow"
              v-if="radioTabs[0] == 5"
            >
              <div class="title-1 mb-4">Суточная альбуминурия</div>
              <div class="text-2 mb-4">
                <b>Альбуминурия в суточной моче</b> – менее 10 мг/сут (А0)
              </div>
            </div>
            <div
              class="d-flex direction-column icc__block-white-plate-overflow"
              v-if="radioTabs[0] == 6"
            >
              <div class="title-1 mb-4">ТТГ, Т4 свободный</div>
              <div class="text-2 mb-4">
                <b>ТТГ</b> – 3,05 мМед/л <br />
                Референсные значения: эутиреоидный статус (0,4-4)
              </div>
              <div class="text-2 mb-4">
                <b>Т4 свободный</b> – 14,3 пмоль/л <br />
                Референсные значения: 10,8-22,0
              </div>
            </div>
            <div
              class="d-flex direction-column icc__block-white-plate-overflow"
              v-if="radioTabs[0] == 7"
            >
              <div class="title-1 mb-4">Кортизол</div>
              <div class="text-2 mb-4">
                <b>Кортизол утренний</b> – 245 нмоль/л (166 – 507 нмоль/л)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="icc__block-steps">
      <Steps
        @refreshClinicalCase="$emit('refreshClinicalCase')"
        @prevStep="$emit('prevStep')"
        @nextStep="$emit('nextStep')"
        :stepsCount="18"
        :activeStep="7"
      />
    </div>
  </div>
</template>

<script>
import Steps from "@/components/interactiveClinicalCase/Steps.vue";
import RadioButton from "@/components/interactiveClinicalCase/RadioButton.vue";
import Select from "@/components/interactiveClinicalCase/Select.vue";
export default {
  name: "ICCStep7",
  components: {
    Steps,
    RadioButton,
    Select,
  },
  data: () => ({
    radioTabs: [],
  }),
  computed: {
    list() {
      return [
        { label: "Биохимический анализ крови", value: 0 },
        { label: "Липидный профиль", value: 1 },
        { label: "Гликированный гемоглобин", value: 2 },
        { label: "Тропонин", value: 3 },
        { label: "NT – proBNP", value: 4 },
        { label: "Суточная альбуминурия", value: 5 },
        { label: "ТТГ, Т4 свободный", value: 6 },
        { label: "Кортизол", value: 7 },
      ];
    },
  },
  watch: {
    radioTabs: {
      handler(n, o) {
        const vm = this;
        if (vm.list[vm.radioTabs[0]]) {
          if (typeof ym !== "undefined") {
            ym(91468266, "reachGoal", "clinical case", {
              "Клинический случай": {
                "Экран 7 - Лабораторные исследования": {
                  "Выбор исследования": {
                    [`Выбрано: "${vm.list[vm.radioTabs[0]].label}"`]: {
                      Params: {
                        ...vm.$root.ymFields,
                      },
                    },
                  },
                },
              },
            });
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/icc_detail.scss";

.icc {
  & .select-form {
    &__select-header {
      margin-bottom: 16px;
      padding: 10px 16px;
      border-radius: 8px;
      background: #f8f8f8;
      font-family: "Roboto", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      text-align: left;
      color: #3c4242;
    }
  }
}
</style>